import { Component, OnInit, inject } from '@angular/core';
import { DOCTOR_ROLES, FREEMIUM_COMPANY_ROLES } from '@app/core/constants/Permissions';
import { User } from '@app/core/models/input/user.model';
import { LoginService } from '@app/core/services/login/login.service';
import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-header-quickapi', 
  templateUrl: './header-quickapi.component.html',
  styleUrl: './header-quickapi.component.scss',
  standalone: false
})
export class HeaderQuickapiComponent implements OnInit {
  private readonly loginService = inject(LoginService);

  faRightFromBracket = faRightFromBracket;

  DOCTOR_ROLES = DOCTOR_ROLES;
  FREEMIUM_COMPANY_ROLES = FREEMIUM_COMPANY_ROLES;

   user?: User;

   ngOnInit(): void {
    this.user = this.loginService.userValue ?? new User();
  }

   logOut() {
    this.loginService.logout();
    window.close();
  }
}
